import { Panel } from "@flightpath/coreui";
import { LinkButton } from "../../../../../components/ui/Button";
import React from "react";
import { Link } from "react-router-dom";
import { IF } from "../../../../../components/hoc/If";
import I18n from "../../../../../core/localization/I18n";
import { Tooltip, TooltipIcon } from "../../../../../components/ui/Tooltip";
import { TooltipPositions } from "@flightpath/coreui/dist/ui/Tooltip";

interface CountDisplayProps {
  count: number | string;
  label: string | React.ReactNode;
  subtitle?: string;
  url?: string;
  permissionLabel?: string;
  canView?: boolean;
  drilldownDisabled?: boolean;
  tooltipContent?: string;
}

export const CountDisplay: React.FC<CountDisplayProps> = props => {
  return (
    <Panel.Panel className={`count-display p-2 ${!props.canView ? "count-display--disabled" : ""}`}>
      <div className="count-display__label row">
        <h2 className="mb-4 text-center">{props.label}</h2>
        <IF condition={!!props.tooltipContent}>
          <Tooltip
            shownElement={<TooltipIcon className="ml-2" />}
            triggeredOn="hover"
            position={TooltipPositions.TOP_RIGHT}
          >
            <Panel.Panel
              background={Panel.PanelBackgrounds.BG_WHITE}
              className="p-2  count-display__tooltip-panel"
              hasBorderRadius={true}
              type={Panel.PanelTypes.OUTLINES}
            >
              <small>{props.tooltipContent}</small>
            </Panel.Panel>
          </Tooltip>
        </IF>
      </div>
      <IF condition={!props.canView}>
        <h4 className="text-center px-3">{props.permissionLabel}</h4>
      </IF>
      <IF condition={+props.count === 0 && props.canView && !!props.url}>
        <LinkButton href={props.url}>{I18n.t("phrases.start")}</LinkButton>
      </IF>
      <IF condition={+props.count > 0 && props.canView}>
        <Link to={props.url || ""} style={{ cursor: `${props.drilldownDisabled ? "default" : "pointer"}` }}>
          <div className="display-xxl text-center">{props.count}</div>
          <h4 className="text-center">{props.subtitle}</h4>
        </Link>
      </IF>
      <IF condition={props.count?.toString().includes("%") && props.canView}>
        <Link to={props.url || ""} style={{ cursor: `${props.drilldownDisabled ? "default" : "pointer"}` }}>
          <div className="display-l text-center">{props.count}</div>
          <h4 className="text-center">{props.subtitle}</h4>
        </Link>
      </IF>
    </Panel.Panel>
  );
};
